export const updateUrl = (customer: string, trackingId: string) => {
  window.history.pushState(
    {},
    "UK's Leading Same Day Delivery Network | CitySprint",
    `${window.location.origin}/${customer}/${trackingId}`
  );
};
